import module from 'viaticos/module.js'

export const schema = {
  autorizado: 'boolean',
  cancelado: 'boolean',
  eliminado: 'boolean',
  editable: 'boolean',
  eliminable: 'boolean',
  fecha: 'datetime',
  importe: 'number',
  pagado: 'boolean',
  timbrado: 'boolean',
  solicitud_id: 'number',
  total: 'number',
}

export class ViaticosViaticoAnticiposAnticipoService {
  constructor ($http) {
    this.$http = $http
  }

  get (solicitudId) {
    return this.$http.get('api/viaticos/viaticos/viatico/anticipos/anticipo', {
      params: {
        solicitud_id: solicitudId,
      },
      schema,
    })
  }

  put (solicitudId, importe) {
    return this.$http.put('api/viaticos/viaticos/viatico/anticipos/anticipo', {importe: importe}, {
      params: {
        solicitud_id: solicitudId,
      },
      schema,
    })
  }
}

module.service('ViaticosViaticoAnticiposAnticipoService', ViaticosViaticoAnticiposAnticipoService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Anticipos/Anticipo.js